import axios from '../../utils/axios'
import { getUser } from 'src/utils/Common';

export const getTasks = () => {
  const SessionUser = getUser(); 
  if (!SessionUser.ServiceShopId || SessionUser.ServiceShopId === "undefined") {
    return Promise.resolve({ data: [] });
  }

  if (!SessionUser.TechnicianId || SessionUser.TechnicianId === "undefined") {
    return Promise.resolve({ data: [] });
  }

  return axios.get(`/GetArtemisOpenServicePaper/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`);
};

export const GetArtemisTodaySummary = () => {
  const SessionUser = getUser();
  return axios.get(`/GetArtemisTodaySummary/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`);
};
